import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import AppStoreIcon from '../../../static/images/appstore_bt.svg';
import GooglePlayIcon from '../../../static/images/googleplay_bt.svg';
import { track } from '../../helpers/Tracking/Analytics';

const AppIcons = ({ baseClassName = 'c-appIcons', modifier = null }) => {
  let className = baseClassName;

  if (modifier) {
    if (modifier.constructor === Array) {
      className = modifier.map(mod => `${className} ${baseClassName}--${mod}`);
    } else {
      className += ` ${baseClassName}--${modifier}`;
    }
  }

  return (
    <React.Fragment>
      {modifier === 'AppFeature' && (
        <p className="c-downloadApp__appIcons__text">Or Download From:</p>
      )}
      <ul className={className}>
        <li>
          <a
            onClick={() => track('click:download-app:ios')}
            target="_blank"
            rel="noopener noreferrer"
            href="https://itunes.apple.com/GB/app/id519652671?mt=8"
          >
            <LazyLoad once offset={100} height={0}>
              <img src={AppStoreIcon} alt="AppStore" />
            </LazyLoad>
          </a>
        </li>
        <li>
          <a
            onClick={() => track('click:download-app:android')}
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=com.justpark.jp"
          >
            <LazyLoad once offset={100} height={0}>
              <img src={GooglePlayIcon} alt="Google Play" />
            </LazyLoad>
          </a>
        </li>
      </ul>
    </React.Fragment>
  );
};

AppIcons.propTypes = {
  baseClassName: PropTypes.string,
  modifier: PropTypes.string
};

AppIcons.defaultProps = {
  baseClassName: 'c-appIcons',
  modifier: null
};

export default AppIcons;
